// extracted by mini-css-extract-plugin
module.exports = {"wrapperFilter":"ModalDetailBagging_wrapperFilter__I42BG","filterColumn":"ModalDetailBagging_filterColumn__3u3yl","actionFilter":"ModalDetailBagging_actionFilter__2Srgp"};